import cn from "classnames"

import { Divider, Dropdown, Flex, Space } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { DownOutlined } from "@/icons"

import styles from "./FooterConfigurationTemplate.module.scss"

import type { FooterConfigurationTemplateProps } from "./FooterConfigurationTemplate.types"

export const FooterConfigurationTemplate = (
  props: FooterConfigurationTemplateProps
) => {
  const { menu, aside, children, disabledSelected, classes = {} } = props
  const { t } = useTranslation()
  const defaultItems = [
    { key: "all", label: t("general.resetAll") },
    {
      key: "selected",
      label: t("general.resetSelected"),
      disabled: disabledSelected
    }
  ]

  return (
    <Flex
      className={cn(styles.container, classes?.container)}
      align="center"
      justify="space-between"
    >
      <Flex flex={1} align="center" justify="space-between">
        {aside}
      </Flex>
      <Flex align="center" justify="flex-end">
        <Dropdown menu={{ items: defaultItems, ...menu }}>
          <Space>
            {t("general.reset")}
            <DownOutlined className={styles.dropdownIcon} />
          </Space>
        </Dropdown>
        <Divider orientation="vertical" />
      </Flex>
      {children}
    </Flex>
  )
}
